/* tslint:disable */
/* eslint-disable */
/**
 * Webclipping
 * WebclippingのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClipReportSummaryV2ChartPieChart
 */
export interface ClipReportSummaryV2ChartPieChart {
    /**
     * 
     * @type {string}
     * @memberof ClipReportSummaryV2ChartPieChart
     */
    genreName: string;
    /**
     * 
     * @type {number}
     * @memberof ClipReportSummaryV2ChartPieChart
     */
    qty: number;
}

export function ClipReportSummaryV2ChartPieChartFromJSON(json: any): ClipReportSummaryV2ChartPieChart {
    return ClipReportSummaryV2ChartPieChartFromJSONTyped(json, false);
}

export function ClipReportSummaryV2ChartPieChartFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClipReportSummaryV2ChartPieChart {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'genreName': json['genre_name'],
        'qty': json['qty'],
    };
}

export function ClipReportSummaryV2ChartPieChartToJSON(value?: ClipReportSummaryV2ChartPieChart | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'genre_name': value.genreName,
        'qty': value.qty,
    };
}

